import { SET_CHATBOT_VISIBILITY } from "./actionTypes";

export const setChatBoxVisibility = data => ({
  type: SET_CHATBOT_VISIBILITY,
  payload: data,
});
